import React from "react";

import PendingPaymentsContent from "../components/payments-linking/pending-payments";

const PendingPayments = () => {
  return <PendingPaymentsContent />;
};

export default PendingPayments;
